import React from "react";
import "./lighting-effects.css";

interface NightOverlayProps {
  opacity?: number;
}

export const NightOverlay: React.FC<NightOverlayProps> = ({
  opacity = 0.6,
}) => {
  return (
    <div className="night-overlay" style={{ opacity }} aria-hidden="true" />
  );
};

interface LightSourceProps {
  color?: string;
  size?: number;
  intensity?: number;
  flicker?: boolean;
  pulse?: boolean; // New prop for pulsing effect
  pulseSpeed?: number; // Speed of the pulse in seconds
  pulseMinOpacity?: number;
  pulseMaxOpacity?: number;
  pulseMinScale?: number;
  pulseMaxScale?: number;
  className?: string;
  style?: React.CSSProperties;
}

export const LightSource: React.FC<LightSourceProps> = ({
  color = "rgba(255, 140, 0, 0.6)",
  size = 300,
  intensity = 1,
  flicker = true,
  pulse = false,
  pulseSpeed = 2,
  pulseMinOpacity = 0.7,
  pulseMaxOpacity = 1,
  pulseMinScale = 0.95,
  pulseMaxScale = 1.05,
  className = "",
  style = {},
}) => {
  return (
    <div
      className={`light-source-container ${className}`}
      style={
        {
          width: size,
          height: size,
          ...style,
        } as React.CSSProperties
      }
    >
      <div
        className={`light-source-pulse ${pulse ? "active" : ""}`}
        style={
          {
            "--pulse-speed": `${pulseSpeed}s`,
            "--pulse-min-op": pulseMinOpacity,
            "--pulse-max-op": pulseMaxOpacity,
            "--pulse-min-scale": pulseMinScale,
            "--pulse-max-scale": pulseMaxScale,
          } as React.CSSProperties
        }
      >
        <div
          className={`light-source-glow ${flicker ? "flicker" : ""}`}
          style={{
            background: `radial-gradient(circle, ${color} 0%, rgba(0,0,0,0) 70%)`,
            opacity: intensity,
          }}
        />
      </div>
    </div>
  );
};
